import { deleteFile as deleteFileAction } from 'actions/entities/files';
import { trackDocCollectorFileDownload as trackDocCollectorFileDownloadAction } from 'actions/tracker';
import { DocumentCard } from 'components/DocumentCollector/DocumentCard';
import { DocumentInVerificationBanner } from 'components/DocumentCollector/DocumentInVerificationBanner';
import { Button } from 'components/ui/Button/Button';
import { Heading } from 'components/ui/Heading/Heading';
import { useLRSContext } from 'contexts';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useTranslations } from 'utils/translations/useTranslations';
import { Back } from '../../components/Back/Back';
export const UploadDocumentation = () => {
  const {
    allCollectionFilesUploaded,
    filesInDocVerifyProcess,
    complete: completeStep,
    documentsCollection,
    i18n,
    navigation,
    onBack,
  } = useLRSContext();
  const [isEnabled, setIsEnabled] = useState(false);
  const dispatch = useDispatch();
  const translations = useTranslations();

  const next = () => {
    completeStep();
    navigation.next();
  };

  const deleteFile = (url: string, fileId: string) => {
    dispatch(deleteFileAction(url, fileId));
  };

  const trackDocCollectorFileDownload = (value: string) => {
    dispatch(trackDocCollectorFileDownloadAction(value));
  };

  useEffect(() => {
    setIsEnabled(allCollectionFilesUploaded);
  }, [allCollectionFilesUploaded]);

  return (
    <div className="UploadDocumentation flex flex-col min-h-full">
      <div className="flex-1">
        <Back onClick={onBack} className="marginBottom-md" />
        <Heading
          as="h2"
          size="large"
          className="fontWeight-semiBold"
          data-testid="upload-documentation-title"
        >
          {i18n.t('checkout.LRS.upload.title')}
        </Heading>
        <ol className="m-0 p-0 list-none">
          {documentsCollection?.documents.map(document => (
            <DocumentCard
              key={document.id}
              deleteFile={deleteFile}
              document={document}
              trackFileDownload={trackDocCollectorFileDownload}
            />
          ))}
        </ol>
        {filesInDocVerifyProcess && <DocumentInVerificationBanner />}
      </div>
      <div className="mt-auto pt-4 pb-4 px-0">
        <Button
          disabled={!isEnabled}
          onClick={next}
          data-testid="next"
          tone="primary"
          size="full"
        >
          {translations.t('checkout.navigation.next')}
        </Button>
      </div>
    </div>
  );
};
